import { render, staticRenderFns } from "./autoCol.vue?vue&type=template&id=1087603a&scoped=true"
import script from "./autoCol.vue?vue&type=script&lang=js"
export * from "./autoCol.vue?vue&type=script&lang=js"
import style1 from "./autoCol.vue?vue&type=style&index=1&id=1087603a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1087603a",
  null
  
)

export default component.exports